import React, {useState, useEffect,useCallback }  from "react";
import './home.scss'
import Axios from 'axios'
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import Tables from '../ChartCus/table/TableCus'
import Chart from '../ChartCus/chart/Chart'
const Swal = require('sweetalert2');
export const ReportCus = () => {
  
  useEffect(() => {
    const token = localStorage.getItem('token')
    fetch('http://27.254.66.164:5000/Author',{
    method: 'POST',
    mode: 'cors',
    headers: {
        'Authorization': 'Bearer '+token,
        'Content-Type': 'application/json',
    },
})
.then(response => response.json())
.then(data => {
        if (data.status === 'ok'){
        } else {
          Swal.fire({
            title: 'กรุณาเข้าสู่ระบบอีกครั้ง',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ตกลง',
          }).then((result) => {
            if (result.isConfirmed) { 
              window.location.href = '/ec-crm/Login'
            }
          })
        }
    });
  },[])
  /*const  now = new Date()
  let firstDay = (new Date(now.getFullYear(), now.getMonth(), 1)).toLocaleDateString("en-CA");
  let lastDay= (new Date(now.getFullYear(), now.getMonth() + 1, 0)).toLocaleDateString("en-CA");
  const [Firstdate, setFirstdate] = useState(firstDay);
  const [Enddate, setEnddate] = useState(lastDay);*/

  const now = new Date();
  const firstDay = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().substring(0, 10);
  const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().substring(0, 10);
  const [Firstdate, setFirstdate] = useState(firstDay);
  const [Enddate, setEnddate] = useState(lastDay);

  const [QuestionId, setQuestionId] = useState("1");
  const [Questionlist, setQuestionlist] = useState([]);
  const [ChartList, setChartList] = useState([]);
  const serch = useCallback(() => {
    Axios.post('http://27.254.66.164:5000/CusList', {
      Firstdate: Firstdate,
      Enddate: Enddate,
      QuestionId:QuestionId
    }).then((response) => {
      setChartList(response.data);
    });
    Axios.post('http://27.254.66.164:5000/Question', {
      QuestionId:QuestionId
    }).then((response) => {
      setQuestionlist(response.data);
    });
    }, [QuestionId,Enddate,Firstdate]);
    useEffect(() => {
      serch();
    },[serch]);
  /*const onSetFirstDate = (event) => {
    setFirstdate((new Date(event.target.value)).toLocaleDateString("en-CA"))
  }
  const onSetEndDate = (event) => {
    setEnddate((new Date(event.target.value)).toLocaleDateString("en-CA"))
  }*/

  const onSetFirstDate = (event) => {
    setFirstdate(new Date(event.target.value).toISOString().substring(0, 10))
  }
  
  const onSetEndDate = (event) => {
    setEnddate(new Date(event.target.value).toISOString().substring(0, 10))
  }

  const onSetQuestion= (event) => {
    setQuestionId(event.target.value)
  }
  return (
    <div className="home">
        <div className="homeContainer">
        <br></br>
          <form align="center">  
            <div className="row justify-content-md-center">  
                <div className="col col-lg-3" >
                    <div className="input-group">
                      <span className="input-group-text"><QuestionMarkIcon /></span>
                      <select className='form-control' value={QuestionId} multiple={false} onChange={onSetQuestion}>
                            <option value="1">อายุ</option>
                            <option value="2">สถานภาพ</option>
                            <option value="3">เพศ</option>
                            <option value="4">อาชีพ</option>
                            <option value="5">รายได้รวมต่อเดือน</option>
                            <option value="6">ทำเลที่สนใจ</option>
                            <option value="7">ประเภทบ้านที่สนใจ</option>
                            <option value="8">ราคาบ้านที่สนใจ</option>
                            <option value="9">โปรโมชั่นที่สนใจ</option>
                            <option value="10">ระยะเวลาผ่อนดาวน์</option>
                            <option value="11">ปัจจัยที่มีผลต่อการซื้อบ้าน</option>
                            <option value="12">ทราบข้อมูลโครงการจากสื่อใด</option>
                      </select>
                    </div>
                </div>  
                <div className="col col-lg-3" >
                  <div className="input-group">
                      <span className="input-group-text"><TodayIcon /></span>
                      <input type="date" className='form-control' value={Firstdate} onChange={onSetFirstDate} data-date-end-date="0d"/>
                  </div>
                </div>  
                <div className="col col-lg-3">
                  <div className="input-group">
                      <span className="input-group-text"><CalendarMonthIcon /></span>
                      <input type="date" className='form-control' value={Enddate} onChange={onSetEndDate} data-date-end-date="0d"/>
                  </div>
                </div>
                
            </div>  
          </form>  
          <br></br>
          <div className="charts">
            <Tables ChartList={ChartList} Questionlist={[Questionlist]}/>
            <Chart ChartList={ChartList} Questionlist={[Questionlist]} /> 
          </div>
        </div>
    </div>
  )
}



